<template>
    <div class="ipc-stat-view">
        <el-dialog
                :title="data.name"
                :visible.sync="dialogVisible"
                :before-close="handleClose"
                center>
            <div id="vue-frame">
                <iframe ref="ifr" @load="frameLoaded" v-if="data.id"
                        :src="getUrl(data.id)" align="center"
                        style="width:100%;height:100%">
                    Ваш браузер не поддерживает встроенные фреймы!
                </iframe>
            </div>
        </el-dialog>
    </div>
</template>

<script>
    import { publicUrl } from "@/api/base";
    export default {
        name: "RaceStatisticModal",
        props: {
            dialogVisible: {
                type: Boolean,
                default: false
            },
            data: {
                type: Object,
                default: function () {
                    return {};
                }
            }
        },
        methods: {
            handleClose: function () {
                this.$emit("visible-change", false);
            },
            frameLoaded: function () {
                console.log('Frame with Race Statistic is loaded');
            },
            getUrl: function(id) {
                return publicUrl + 'stats/?id=' + id;
            }
        }
    }
</script>

<style>
    .ipc-stat-view .el-dialog__headerbtn {
        position: absolute;
        top: 10px;
        right: 10px;
        padding: 0;
        background: 0 0;
        border: none;
        outline: 0;
        cursor: pointer;
        font-size: 25px;
    }

    .ipc-stat-view .el-dialog__title {
        display: none;
    }

    .ipc-stat-view .el-dialog__headerbtn .el-dialog__close {
        color: #000000;
    }

    .ipc-stat-view .el-dialog__header {
        padding: 0px;
    }

    .ipc-stat-view .el-dialog--center .el-dialog__body {
        padding: 5px;

    }

    .ipc-stat-view .el-dialog--center .el-dialog__body > div {
        overflow: hidden;
    }

    .ipc-stat-view .el-dialog{
        margin-top: 0 !important;
        width: 100%;
        height: 98vh;
    }
    .ipc-stat-view #vue-frame,
    .ipc-stat-view .el-dialog__body{
        height: 97vh;
    }
</style>
